import { useState, useRef, useEffect } from 'react';
import { useRouter } from 'next/router';

import {
  analytics,
  getContactSubmitDetail,
  getContactDDSubmitDetail,
  getContactSubmitSuccess,
  getContactDDSubmitSuccess,
} from '@/utils/analytics';
import { isDDEnv } from '@/utils/helper';

import TextInput from '@/atoms/TextInput/TextInput';
import Select from '@/atoms/Select/Select';
import Textarea from '@/atoms/Textarea/Textarea';
import Text from '@/atoms/Text/Text';
import Button from '@/atoms/Button/Button';

function ContactForm() {
  const { locale } = useRouter();
  const isDD = isDDEnv();

  //load recaptcha script if not already exist
  useEffect(() => {
    const loadScriptByURL = (id, url, callback) => {
      const isScriptExist = document.getElementById(id);

      if (!isScriptExist) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = url;
        script.id = id;
        script.onload = function () {
          if (callback) callback();
        };
        document.body.appendChild(script);
      }

      if (isScriptExist && callback) callback();
    };

    // load the script by passing the URL
    loadScriptByURL(
      'recaptcha-key',
      `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}`
    );
  }, []);

  const countries = useRef([
    { label: 'Andorra', value: 'AD' },
    { label: 'Afghanistan', value: 'AF' },
    { label: 'Antigua and Barbuda', value: 'AG' },
    { label: 'Anguilla', value: 'AI' },
    { label: 'Albania', value: 'AL' },
    { label: 'Armenia', value: 'AM' },
    { label: 'Angola', value: 'AO' },
    { label: 'Antarctica', value: 'AQ' },
    { label: 'Argentina', value: 'AR' },
    { label: 'American Samoa', value: 'AS' },
    { label: 'Austria', value: 'AT' },
    { label: 'Australia', value: 'AU' },
    { label: 'Aruba', value: 'AW' },
    { label: 'Aland', value: 'AX' },
    { label: 'Azerbaijan', value: 'AZ' },
    { label: 'Bosnia and Herzegovina', value: 'BA' },
    { label: 'Barbados', value: 'BB' },
    { label: 'Bangladesh', value: 'BD' },
    { label: 'Belgium', value: 'BE' },
    { label: 'Burkina Faso', value: 'BF' },
    { label: 'Bulgaria', value: 'BG' },
    { label: 'Bahrain', value: 'BH' },
    { label: 'Burundi', value: 'BI' },
    { label: 'Benin', value: 'BJ' },
    { label: 'Saint Barthélemy', value: 'BL' },
    { label: 'Bermuda', value: 'BM' },
    { label: 'Brunei', value: 'BN' },
    { label: 'Bolivia', value: 'BO' },
    { label: 'Bonaire', value: 'BQ' },
    { label: 'Brazil', value: 'BR' },
    { label: 'Bahamas', value: 'BS' },
    { label: 'Bhutan', value: 'BT' },
    { label: 'Bouvet Island', value: 'BV' },
    { label: 'Botswana', value: 'BW' },
    { label: 'Belarus', value: 'BY' },
    { label: 'Belize', value: 'BZ' },
    { label: 'Canada', value: 'CA' },
    { label: 'Cocos [Keeling] Islands', value: 'CC' },
    { label: 'Democratic Republic of the Congo', value: 'CD' },
    { label: 'Central African Republic', value: 'CF' },
    { label: 'Republic of the Congo', value: 'CG' },
    { label: 'Switzerland', value: 'CH' },
    { label: 'Ivory Coast', value: 'CI' },
    { label: 'Cook Islands', value: 'CK' },
    { label: 'Chile', value: 'CL' },
    { label: 'Cameroon', value: 'CM' },
    { label: 'China', value: 'CN' },
    { label: 'Colombia', value: 'CO' },
    { label: 'Costa Rica', value: 'CR' },
    { label: 'Cuba', value: 'CU' },
    { label: 'Cape Verde', value: 'CV' },
    { label: 'Curacao', value: 'CW' },
    { label: 'Christmas Island', value: 'CX' },
    { label: 'Cyprus', value: 'CY' },
    { label: 'Czech Republic', value: 'CZ' },
    { label: 'Germany', value: 'DE' },
    { label: 'Djibouti', value: 'DJ' },
    { label: 'Denmark', value: 'DK' },
    { label: 'Dominica', value: 'DM' },
    { label: 'Dominican Republic', value: 'DO' },
    { label: 'Algeria', value: 'DZ' },
    { label: 'Ecuador', value: 'EC' },
    { label: 'Estonia', value: 'EE' },
    { label: 'Egypt', value: 'EG' },
    { label: 'Western Sahara', value: 'EH' },
    { label: 'Eritrea', value: 'ER' },
    { label: 'Spain', value: 'ES' },
    { label: 'Ethiopia', value: 'ET' },
    { label: 'Finland', value: 'FI' },
    { label: 'Fiji', value: 'FJ' },
    { label: 'Falkland Islands', value: 'FK' },
    { label: 'Micronesia', value: 'FM' },
    { label: 'Faroe Islands', value: 'FO' },
    { label: 'France', value: 'FR' },
    { label: 'Gabon', value: 'GA' },
    { label: 'United Kingdom', value: 'GB' },
    { label: 'Grenada', value: 'GD' },
    { label: 'Georgia', value: 'GE' },
    { label: 'French Guiana', value: 'GF' },
    { label: 'Guernsey', value: 'GG' },
    { label: 'Ghana', value: 'GH' },
    { label: 'Gibraltar', value: 'GI' },
    { label: 'Greenland', value: 'GL' },
    { label: 'Gambia', value: 'GM' },
    { label: 'Guinea', value: 'GN' },
    { label: 'Guadeloupe', value: 'GP' },
    { label: 'Equatorial Guinea', value: 'GQ' },
    { label: 'Greece', value: 'GR' },
    { label: 'South Georgia and the South Sandwich Islands', value: 'GS' },
    { label: 'Guatemala', value: 'GT' },
    { label: 'Guam', value: 'GU' },
    { label: 'Guinea-Bissau', value: 'GW' },
    { label: 'Guyana', value: 'GY' },
    { label: 'Hong Kong', value: 'HK' },
    { label: 'Heard Island and McDonald Islands', value: 'HM' },
    { label: 'Honduras', value: 'HN' },
    { label: 'Croatia', value: 'HR' },
    { label: 'Haiti', value: 'HT' },
    { label: 'Hungary', value: 'HU' },
    { label: 'Indonesia', value: 'ID' },
    { label: 'Ireland', value: 'IE' },
    { label: 'Israel', value: 'IL' },
    { label: 'Isle of Man', value: 'IM' },
    { label: 'India', value: 'IN' },
    { label: 'British Indian Ocean Territory', value: 'IO' },
    { label: 'Iraq', value: 'IQ' },
    { label: 'Iran', value: 'IR' },
    { label: 'Iceland', value: 'IS' },
    { label: 'Italy', value: 'IT' },
    { label: 'Jersey', value: 'JE' },
    { label: 'Jamaica', value: 'JM' },
    { label: 'Jordan', value: 'JO' },
    { label: 'Japan', value: 'JP' },
    { label: 'Kenya', value: 'KE' },
    { label: 'Kyrgyzstan', value: 'KG' },
    { label: 'Cambodia', value: 'KH' },
    { label: 'Kiribati', value: 'KI' },
    { label: 'Comoros', value: 'KM' },
    { label: 'Saint Kitts and Nevis', value: 'KN' },
    { label: 'North Korea', value: 'KP' },
    { label: 'South Korea', value: 'KR' },
    { label: 'Kuwait', value: 'KW' },
    { label: 'Cayman Islands', value: 'KY' },
    { label: 'Kazakhstan', value: 'KZ' },
    { label: 'Laos', value: 'LA' },
    { label: 'Lebanon', value: 'LB' },
    { label: 'Saint Lucia', value: 'LC' },
    { label: 'Liechtenstein', value: 'LI' },
    { label: 'Sri Lanka', value: 'LK' },
    { label: 'Liberia', value: 'LR' },
    { label: 'Lesotho', value: 'LS' },
    { label: 'Lithuania', value: 'LT' },
    { label: 'Luxembourg', value: 'LU' },
    { label: 'Latvia', value: 'LV' },
    { label: 'Libya', value: 'LY' },
    { label: 'Morocco', value: 'MA' },
    { label: 'Monaco', value: 'MC' },
    { label: 'Moldova', value: 'MD' },
    { label: 'Montenegro', value: 'ME' },
    { label: 'Saint Martin', value: 'MF' },
    { label: 'Madagascar', value: 'MG' },
    { label: 'Marshall Islands', value: 'MH' },
    { label: 'North Macedonia', value: 'MK' },
    { label: 'Mali', value: 'ML' },
    { label: 'Myanmar [Burma]', value: 'MM' },
    { label: 'Mongolia', value: 'MN' },
    { label: 'Macao', value: 'MO' },
    { label: 'Northern Mariana Islands', value: 'MP' },
    { label: 'Martinique', value: 'MQ' },
    { label: 'Mauritania', value: 'MR' },
    { label: 'Montserrat', value: 'MS' },
    { label: 'Malta', value: 'MT' },
    { label: 'Mauritius', value: 'MU' },
    { label: 'Maldives', value: 'MV' },
    { label: 'Malawi', value: 'MW' },
    { label: 'Mexico', value: 'MX' },
    { label: 'Malaysia', value: 'MY' },
    { label: 'Mozambique', value: 'MZ' },
    { label: 'Namibia', value: 'NA' },
    { label: 'New Caledonia', value: 'NC' },
    { label: 'Niger', value: 'NE' },
    { label: 'Norfolk Island', value: 'NF' },
    { label: 'Nigeria', value: 'NG' },
    { label: 'Nicaragua', value: 'NI' },
    { label: 'Netherlands', value: 'NL' },
    { label: 'Norway', value: 'NO' },
    { label: 'Nepal', value: 'NP' },
    { label: 'Nauru', value: 'NR' },
    { label: 'Niue', value: 'NU' },
    { label: 'New Zealand', value: 'NZ' },
    { label: 'Oman', value: 'OM' },
    { label: 'Panama', value: 'PA' },
    { label: 'Peru', value: 'PE' },
    { label: 'French Polynesia', value: 'PF' },
    { label: 'Papua New Guinea', value: 'PG' },
    { label: 'Philippines', value: 'PH' },
    { label: 'Pakistan', value: 'PK' },
    { label: 'Poland', value: 'PL' },
    { label: 'Saint Pierre and Miquelon', value: 'PM' },
    { label: 'Pitcairn Islands', value: 'PN' },
    { label: 'Puerto Rico', value: 'PR' },
    { label: 'Palestine', value: 'PS' },
    { label: 'Portugal', value: 'PT' },
    { label: 'Palau', value: 'PW' },
    { label: 'Paraguay', value: 'PY' },
    { label: 'Qatar', value: 'QA' },
    { label: 'Réunion', value: 'RE' },
    { label: 'Romania', value: 'RO' },
    { label: 'Serbia', value: 'RS' },
    { label: 'Russia', value: 'RU' },
    { label: 'Rwanda', value: 'RW' },
    { label: 'Saudi Arabia', value: 'SA' },
    { label: 'Solomon Islands', value: 'SB' },
    { label: 'Seychelles', value: 'SC' },
    { label: 'Sudan', value: 'SD' },
    { label: 'Sweden', value: 'SE' },
    { label: 'Singapore', value: 'SG' },
    { label: 'Saint Helena', value: 'SH' },
    { label: 'Slovenia', value: 'SI' },
    { label: 'Svalbard and Jan Mayen', value: 'SJ' },
    { label: 'Slovakia', value: 'SK' },
    { label: 'Sierra Leone', value: 'SL' },
    { label: 'San Marino', value: 'SM' },
    { label: 'Senegal', value: 'SN' },
    { label: 'Somalia', value: 'SO' },
    { label: 'Suriname', value: 'SR' },
    { label: 'South Sudan', value: 'SS' },
    { label: 'São Tomé and Príncipe', value: 'ST' },
    { label: 'El Salvador', value: 'SV' },
    { label: 'Sint Maarten', value: 'SX' },
    { label: 'Syria', value: 'SY' },
    { label: 'Swaziland', value: 'SZ' },
    { label: 'Turks and Caicos Islands', value: 'TC' },
    { label: 'Chad', value: 'TD' },
    { label: 'French Southern Territories', value: 'TF' },
    { label: 'Togo', value: 'TG' },
    { label: 'Thailand', value: 'TH' },
    { label: 'Tajikistan', value: 'TJ' },
    { label: 'Tokelau', value: 'TK' },
    { label: 'East Timor', value: 'TL' },
    { label: 'Turkmenistan', value: 'TM' },
    { label: 'Tunisia', value: 'TN' },
    { label: 'Tonga', value: 'TO' },
    { label: 'Turkey', value: 'TR' },
    { label: 'Trinidad and Tobago', value: 'TT' },
    { label: 'Tuvalu', value: 'TV' },
    { label: 'Taiwan', value: 'TW' },
    { label: 'Tanzania', value: 'TZ' },
    { label: 'Uganda', value: 'UG' },
    { label: 'Ukraine', value: 'UA' },
    { label: 'United Arab Emirates', value: 'AE' },
    { label: 'U.S. Minor Outlying Islands', value: 'UM' },
    { label: 'United States', value: 'US' },
    { label: 'Uruguay', value: 'UY' },
    { label: 'Uzbekistan', value: 'UZ' },
    { label: 'Vatican City', value: 'VA' },
    { label: 'Saint Vincent and the Grenadines', value: 'VC' },
    { label: 'Venezuela', value: 'VE' },
    { label: 'British Virgin Islands', value: 'VG' },
    { label: 'U.S. Virgin Islands', value: 'VI' },
    { label: 'Vietnam', value: 'VN' },
    { label: 'Vanuatu', value: 'VU' },
    { label: 'Wallis and Futuna', value: 'WF' },
    { label: 'Samoa', value: 'WS' },
    { label: 'Kosovo', value: 'XK' },
    { label: 'Yemen', value: 'YE' },
    { label: 'Mayotte', value: 'YT' },
    { label: 'South Africa', value: 'ZA' },
    { label: 'Zambia', value: 'ZM' },
    { label: 'Zimbabwe', value: 'ZW' },
  ]);

  const roles = useRef([
    { label: 'Chef', value: 'Chef' },
    { label: 'Food service', value: 'Food service' },
    { label: 'Retail', value: 'Retail' },
    { label: 'Wholesaler or distributor', value: 'Wholesaler or distributor' },
    { label: 'Wagyu enthusiast', value: 'Wagyu enthusiast' },
    { label: 'Beef industry member', value: 'Beef industry member' },
    { label: 'Cattle producer', value: 'Cattle producer' },
    { label: 'Restaurant owner', value: 'Restaurant owner' },
    { label: 'Home cook', value: 'Home cook' },
    { label: 'Other', value: 'Other' },
  ]);

  const [firstName, setFirstName] = useState('');
  const [firstNameIsFocus, setFirstNameIsFocus] = useState(false);
  const [lastName, setLastName] = useState('');
  const [lastNameIsFocus, setLastNameIsFocus] = useState(false);
  const [email, setEmail] = useState('');
  const [emailIsFocus, setEmailIsFocus] = useState(false);
  const [enquiry, setEnquiry] = useState('');
  const [enquiryIsFocus, setEnquiryIsFocus] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [countryIsFocus, setCountryIsFocus] = useState(false);
  const [selectedRole, setSelectedRole] = useState('');
  const [roleIsFocus, setRoleIsFocus] = useState(false);
  const [restaurant, setRestaurant] = useState('');
  const [restaurantIsFocus, setRestaurantIsFocus] = useState(false);
  const [contactEnquiryIsSent, setContactEnquiryIsSent] = useState(false);

  const handleFormSubmit = (e) => {
    e.preventDefault();

    enquiryAnalytics(e);

    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY, {
          action: 'submit',
        })
        .then((token) => {
          submitContactEnquiry(token);
        });
    });
  };

  useEffect(() => {
    setContactEnquiryIsSent(false);
    setFirstName('');
    setLastName('');
    setEmail('');
    setEnquiry('');
    setSelectedCountry('');
    setSelectedRole('');
    setRestaurant('');
  }, []);

  useEffect(() => {
    if (contactEnquiryIsSent) {
      enquirySuccessAnalytics();
    }
  }, [contactEnquiryIsSent]);

  const enquiryAnalytics = (e) => {
    analytics({
      window,
      document,
      detail: isDD
        ? getContactDDSubmitDetail(null)
        : getContactSubmitDetail(e, {
            country: countries.current.find((i) => i.value === selectedCountry)
              ?.label,
            role: roles.current.find((i) => i.value === selectedRole)?.label,
          }),
    });
  };

  const enquirySuccessAnalytics = () => {
    analytics({
      window,
      document,
      detail: isDD
        ? getContactDDSubmitSuccess(null)
        : getContactSubmitSuccess(null, {
            country: countries.current.find((i) => i.value === selectedCountry)
              ?.label,
            role: roles.current.find((i) => i.value === selectedRole)?.label,
          }),
    });
  };

  const submitContactEnquiry = async (token) => {
    const params = {
      firstName,
      lastName,
      email,
      country: countries.current.find((i) => i.value === selectedCountry)
        ?.label,
      role: roles.current.find((i) => i.value === selectedRole)?.label,
      restaurant,
      enquiry,
      'g-recaptcha-response': token,
    }

    const response = await fetch(`/api/contact?${new URLSearchParams(params).toString()}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      //body: JSON.stringify(params),
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    } else {
      setContactEnquiryIsSent(true);
    }
  };

  return (
    <form
      className="aaco-contact-form container flex flex-col"
      onSubmit={handleFormSubmit}
    >
      <div className="flex flex-col md:flex-row justify-between mb-[30px]">
        <div className="flex-1 mb-[30px] md:mb-0 md:mr-7">
          <TextInput
            value={firstName}
            name="contact-first-name"
            onChange={(e) => setFirstName(e.target.value)}
            onFocus={() => setFirstNameIsFocus(true)}
            onBlur={() => setFirstNameIsFocus(false)}
            placeholder={locale === 'ko-KR' ? '이름' : 'FIRST NAME'}
            required={true}
            isFocus={firstNameIsFocus}
            tabIndex={1}
          />
        </div>
        <div className="flex-1">
          <TextInput
            name="contact-last-name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            onFocus={() => setLastNameIsFocus(true)}
            onBlur={() => setLastNameIsFocus(false)}
            placeholder={locale === 'ko-KR' ? '성' : 'LAST NAME'}
            required={true}
            isFocus={lastNameIsFocus}
            tabIndex={2}
          />
        </div>
      </div>
      <div className="flex flex-col md:flex-row justify-between mb-[30px]">
        <div className="flex-1 mb-[30px] md:mb-0 md:mr-7">
          <TextInput
            name="contact-email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onFocus={() => setEmailIsFocus(true)}
            onBlur={() => setEmailIsFocus(false)}
            placeholder={locale === 'ko-KR' ? '이메일' : 'EMAIL ADDRESS'}
            type="email"
            required={true}
            isFocus={emailIsFocus}
            tabIndex={3}
          />
        </div>
        <div className="flex-1">
          <Select
            name="contact-country"
            placeholder={locale === 'ko-KR' ? '나라' : 'COUNTRY'}
            required={true}
            value={selectedCountry}
            options={countries.current.sort((a, b) =>
              a.label > b.label ? 1 : -1
            )}
            onChange={(e) => setSelectedCountry(e.target.value)}
            onFocus={() => setCountryIsFocus(true)}
            onBlur={() => setCountryIsFocus(false)}
            isFocus={countryIsFocus}
            tabIndex={4}
          />
        </div>
      </div>
      {!isDD && (
        <>
          <div className="flex flex-col md:flex-row justify-between mb-[30px]">
            <div className="flex-1 mb-[30px] md:mb-0 md:mr-7">
              <Select
                name="contact-role"
                placeholder="ROLE"
                required={true}
                value={selectedRole}
                options={roles.current}
                onChange={(e) => setSelectedRole(e.target.value)}
                onFocus={() => setRoleIsFocus(true)}
                onBlur={() => setRoleIsFocus(false)}
                isFocus={roleIsFocus}
                tabIndex={5}
              />
            </div>
            <div className="flex-1">
              <TextInput
                name="contact-restaurant"
                value={restaurant}
                onChange={(e) => setRestaurant(e.target.value)}
                onFocus={() => setRestaurantIsFocus(true)}
                onBlur={() => setRestaurantIsFocus(false)}
                placeholder="RESTAURANT / VENUE (IF APPLICABLE)"
                isFocus={restaurantIsFocus}
                tabIndex={6}
              />
            </div>
          </div>
        </>
      )}
      <div className="flex-1 mb-[30px]">
        <Textarea
          name="contact-enquiry"
          placeholder={
            locale === 'ko-KR' ? '문의를 작성해 주세요' : 'TYPE ENQUIRY HERE'
          }
          required={true}
          onChange={(e) => setEnquiry(e.target.value)}
          onFocus={() => setEnquiryIsFocus(true)}
          onBlur={() => setEnquiryIsFocus(false)}
          isFocus={enquiryIsFocus}
          tabIndex={7}
          value={enquiry}
        />
      </div>
      <div className="flex-1 mb-[30px] dd-kr:mb-0 dd-en:mb-0">
        {!contactEnquiryIsSent ? (
          <Button
            style={
              'aaco-cta link-invert cursor-pointer flex items-center bg-acacia rounded-button w-fit px-5 h-10 dd-kr:bg-actual-dd-gold dd-en:bg-actual-dd-gold'
            }
            tabIndex={8}
          >
            <Text tag="button" style="text-uppercase text-white">
              {locale === 'ko-KR' ? '문의 보내기' : 'Send enquiry'}
            </Text>
          </Button>
        ) : (
          <Text tag="button" style="text-violet dd-kr:text-white dd-en:text-white">
            Thank you for your enquiry, we will respond as soon as possible.
          </Text>
        )}
      </div>
    </form>
  );
}

export default ContactForm;
